import { render, staticRenderFns } from "./MobilePhoneField.vue?vue&type=template&id=e5c05412&functional=true&"
import script from "./MobilePhoneField.vue?vue&type=script&lang=js&"
export * from "./MobilePhoneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports